import type { Coordinates } from 'shared/types'
import { imagesPaths } from 'app/common/utils'
import { markersBase64 } from './markersBase64'

export const displayGeocodedAddressMarker = (map: any, coords: Coordinates) => {
    let geocodedAddressMarker = new window.woosmap.map.Marker({
        position: coords,
        icon: {
            url: markersBase64.markerPin
        }
    })
    geocodedAddressMarker.setMap(map)
}

export const displayUserPositionMarker = (map: any, coords: Coordinates) => {
    let userMarker = new window.woosmap.map.Marker({
        position: coords,
        icon: {
            url: markersBase64.markerUser
        }
    })
    userMarker.setMap(map)
}
